import http from "../index";
let lang = localStorage.getItem('2d3d-language')

// 获取国际区号
export const getShowTelCode = () =>{
	return http.post("/Register/showTelCode");
};

// 发送手机验证码
export const sendPhoneCode = (obj) =>{
	return http.post("/v3/ActionRegister/sendPhoneCode",obj);
};


// 密码登录-手机或者邮箱登录接口
export const loginPassword = (obj) =>{
	return http.post("/v3/ActionRegister/loginPassword?lang="+lang,obj);
};

// 密码登录-手机或者邮箱登录接口
export const loginPhone = (obj) =>{
	return http.post("/v3/ActionRegister/loginPhone?lang="+lang,obj);
};

// 扫码登录-获取uuid
export const loginScan = () =>{
	return http.post("/v3/ActionRegister/loginScan",{
		scene:'integral'
	});
};

// 扫码登录-轮询是否登录成功
export const listenScan = (obj) =>{
	return http.post("/v3/ActionRegister/listenScan",obj);
};

// 忘记密码-手机找回
export const forgotPasswordByPhone = (obj) =>{
	return http.post("/v3/ActionRegister/forgotPasswordByPhone?lang="+lang,obj);
};

// 忘记密码-邮箱找回
export const forgotPasswordByEmail = (obj) =>{
	return http.post("/v3/ActionRegister/forgotPasswordByEmail",obj);
};

// 通过token获取用户信息
export const loginToken = (token) =>{
	return http.post("/v3/ActionRegister/loginToken?lang="+lang,{token});
};

// 谷歌登录
export const googleLogin = (obj)=>{
	return http.post("/v3/ActionRegister/googleLogin",obj)
}